// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Dazn","info":"PatientInfo_info__3h9Pa"};